import React, {Component} from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import red from '@material-ui/core/colors/red';
import { KOBOO_LIGHT_GREY, KOBOO_OTHER_BLUE } from '../../constants/colors';
import KobooDialog from '../Layout/KobooDialog.jsx';
import LateRentTable from "./LateRentTable";

const styles = () => ({
  card: {
    display: 'flex',
  },
  content: {
    flex: '1 0 auto',
    paddingBottom: '10px',
    paddingTop: '14px',
    height: '2em',
    fontSize: '1.5em',
  },
  icon: {
    width: '2em',
    height: '2em',
    fontSize: '2em',
    padding: '0.4em',
    backgroundColor: KOBOO_OTHER_BLUE,
  },
  alert: {
    backgroundColor: red[500],
    padding: '10px',
    fontSize: '1.5em',
    height: '2em',
    width: '2em',
    color: KOBOO_LIGHT_GREY,
    '&:hover': {
      color: KOBOO_OTHER_BLUE
    }
  },
  actions: {
    padding: '0 10px 0 0'
  }
});

const INITIAL_STATE = {
  dialog: {
    open: false,
    item: '',
  }
};

export class StatBlock extends Component {

  static propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    lateRents: PropTypes.array,
    bikes: PropTypes.array,
    sites: PropTypes.array,
    renters: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  // Handler

  handleClose = () => {
    this.setState({ ...INITIAL_STATE });
  };

  handleClickOpen = () => {
    this.setState({ dialog: {
        ...this.state.dialog,
        open: true,

      }});
  };

  render() {
    const { classes, lateRents } = this.props;
    return (
      <Grid item xs={12} sm={12} md={3}>
        {lateRents && lateRents.length > 0 &&
          <KobooDialog
          id="dialog_late_rents"
          open={this.state.dialog.open}
          handleClose={this.handleClose}
          dialogTitle={`Locations en retard`}
          handleCloseCancel={this.handleClose}
          textField={<LateRentTable
          rents={lateRents}
          bikes={this.props.bikes}
          sites={this.props.sites}
          renters={this.props.renters}
        />}
          cancelText="OK"
          />
        }
        <Card className={classes.card}>
          <CardHeader
            className={classes.icon}
            component={this.props.icon}
          />
          <CardContent className={classes.content}>
            <Typography variant="h5">{this.props.text}</Typography>
          </CardContent>
          {lateRents && lateRents.length > 0 &&
          <CardActions className={classes.actions} disableSpacing>
            <IconButton
              className={classes.alert}
              onClick={this.handleClickOpen}
            >
              {lateRents.length}
            </IconButton>
          </CardActions>
          }
        </Card>
      </Grid>);
  }
}

export default withStyles(styles)(StatBlock);



// WEBPACK FOOTER //
// ./src/components/Dashboard/StatBlock.jsx